// types
import { ProjectColorType } from "../../types/ProjectColorType";

export const MyStatusColor: ProjectColorType[] = [
  { id: 12, color: "#0179CF", name: "blue1" },
  { id: 32, color: "#200CBE", name: "blue2" },
  { id: 2, color: "#90D1FF", name: "blue_light" },
  { id: 92, color: "#ACAAA9", name: "gray1_40" },
  { id: 82, color: "#94C3E4", name: "blue1_40" },
];

export const ForDreamColor: ProjectColorType[] = [
  { id: 12, color: "#030D22", name: "dark" },
  { id: 32, color: "#1F2AD1", name: "blue1" },
  { id: 2, color: "#560DAA", name: "purple" },
  { id: 92, color: "#1E34E1", name: "blue2" },
  { id: 82, color: "#E545B2", name: "pink" },
];

export const IDriverColor: ProjectColorType[] = [
  { id: 12, color: "#CDEB00", name: "Lime" },
  { id: 32, color: "#0E0F12", name: "Black" },
  { id: 2, color: "#20222A", name: "Graphite" },
  { id: 92, color: "#94AF00", name: "Deep lime" },
  { id: 82, color: "#EDEDED", name: "White" },
];

export const VoiceNotesColor: ProjectColorType[] = [
  { id: 12, color: "#4C6EF5", name: "Blue" },
  { id: 32, color: "#2B3F9E", name: "Deep blue" },
  { id: 2, color: "#8AA4FF", name: "Light blue" },
  { id: 92, color: "#0E111A", name: "Dark" },
  { id: 82, color: "#C7D2F5", name: "Pale blue" },
];

export const PlanerColor: ProjectColorType[] = [
  { id: 12, color: "#B88AFE", name: "Purple" },
  { id: 32, color: "#7D40DB", name: "Deep purple" },
  { id: 2, color: "#FE8A96", name: "Red" },
  { id: 92, color: "#94DF21", name: "Green" },
  { id: 82, color: "#322F35", name: "Gray" },
];
